import React from 'react';
import { Flex } from 'rebass/styled-components';
import { Message } from '@getro/rombo';
import PropTypes from 'prop-types';
import { ContactsReconnectBanner } from '../../components/molecules/contactsReconnectBanner';

export const ContactsLinkedinSync = ({ linkedinSync, activeNetwork }) => (
  <Flex flexDirection="column" sx={{ gap: '16px', '&& > div:last-child': { mb: '40px' } }}>
    {linkedinSync?.syncStatus === 'not_completed' && (
      <Message>We’re syncing your LinkedIn connections, this may take up to 3 hours.</Message>
    )}
    {linkedinSync?.syncStatus === 'reconnection_needed' && <ContactsReconnectBanner network={activeNetwork} />}
  </Flex>
);

ContactsLinkedinSync.propTypes = {
  linkedinSync: PropTypes.object.isRequired,
  activeNetwork: PropTypes.object.isRequired,
};
